import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#fr_svg__clip0_1486_8202)\"><rect y=\"1\" width=\"20\" height=\"18\" rx=\"4\" fill=\"white\"></rect><rect x=\"5.5\" y=\"1.5\" width=\"9\" height=\"17\" stroke=\"black\" stroke-opacity=\"0.1\"></rect><rect y=\"1\" width=\"6.75\" height=\"18\" fill=\"#4084E8\"></rect><rect x=\"13.25\" y=\"1\" width=\"6.75\" height=\"18\" fill=\"#E84040\"></rect></g><defs><clipPath id=\"fr_svg__clip0_1486_8202\"><rect y=\"1\" width=\"20\" height=\"18\" rx=\"4\" fill=\"white\"></rect></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }